module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.expanded != true && _vm.$route.query.expanded != 'true'),
      expression: "$route.query.expanded!=true && $route.query.expanded != 'true'"
    }],
    staticClass: "widgets"
  }, [_vm._v("\n    " + _vm._s(_vm.getCurrentWeek) + "\n\n    "), (!_vm.roles.includes('LiteStudent')) ? _c('div', [(_vm.$route.name !== 'home' &&
    (_vm.localStorage.roles.includes('Student') ||
      _vm.localStorage.roles.includes('CampusStudent') ||
      _vm.localStorage.roles.includes('GlobalMentor') ||
      _vm.localStorage.roles.includes('Recruiter') ||
      _vm.localStorage.roles.includes('Mentor') ||
      _vm.localStorage.roles.includes('CampusMentor')
    )) ? _c('next-live-session', {
    attrs: {
      "location": 'sidebar'
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.localStorage.roles.indexOf('Supervisor') > -1) ? _c('supervisor-sessions') : _vm._e(), _vm._v(" "), (_vm.roles.includes('Supervisor') || _vm.roles.includes('Mentor')) ? _c('live-session-file-share') : _vm._e(), _vm._v(" "), (!_vm.roles.includes('LiteStudent')) ? _c('div', [((_vm.roles.includes('CampusStudent') || _vm.roles.includes('Student')) && _vm.$root.preSemester == false) ? _c('class-alerts') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.roles.includes('Supervisor')) ? _c('supervisor-alerts') : _vm._e(), _vm._v(" "), (_vm.roles.includes('Student')) ? _c('live-session-file-share') : _vm._e(), _vm._v(" "), (!_vm.roles.includes('LiteStudent')) ? _c('div', [(_vm.roles.includes('Student') || _vm.roles.includes('CampusStudent') || _vm.roles.includes('Supervisor') || _vm.roles.includes('Mentor')) ? _c('workshops') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isNotRecruiter && !_vm.roles.includes('LiteStudent')) ? _c('forum-updates') : _vm._e(), _vm._v(" "), (_vm.roles.includes('CampusStudent') && !_vm.roles.includes('LiteStudent')) ? _c('support') : _vm._e(), _vm._v(" "), (!_vm.roles.includes('LiteStudent')) ? _c('div', [(_vm.inProduction || _vm.rocketChatEnabled) ? _c('rocket-chat') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center image-container"
  }, [_c('div', {
    staticClass: "sidebar-jar"
  }, [_c('div', {
    staticClass: "white sidebar-jar-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "blue sidebar-jar-image"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cb5a0f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Widgets.vue
// module id = 2088
// module chunks = 2